import React, { useEffect, useState } from "react";
import {
  addEducationMajor,
  deleteEducationMajor,
  editEducationMajor,
  getEducationMajor
} from "contexts/API/CommonSetting/MasterData";

import MaterialTable from "components/Table/MaterialTable";
import { useSweetAlert } from "components/Alert/SweetAlert";

const EducationMajor = props => {
  const { sweetAlerts } = useSweetAlert();
  const [columns] = useState([
    {
      title: "eduMajorId",
      field: "eduMajorId",
      hidden: true
    },
    {
      title: "ชื่อสาขาวิชา",
      field: "eduMajorName",
      cellStyle: {
        minWidth: "600px"
      }
    }
  ]);

  const [data, setData] = useState([]);
  useEffect(() => {
    getEducationMajor()
      .then(result => {
        setData(result.data.data);
      })
      .catch(err => {
        sweetAlerts.error("ไม่สามารถดึงข้อมูล", err.toString());
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const optionsTable = { pageSize: 10 };
  return (
    <MaterialTable
      title={"สาขาวิชา"}
      options={optionsTable}
      columns={columns}
      data={data}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
            addEducationMajor(newData.eduMajorName)
              .then(result => {
                //console.log("result>>",result);
                newData.eduMajorId = result.data.data.eduMajorId;
                setData([...data, newData]);
                sweetAlerts.success("เพิ่มข้อมูลเรียบร้อยแล้ว");
              })
              .catch(err => {
                sweetAlerts.error("ไม่สามารถเพิ่มข้อมูลได้", err.toString());
              });

            resolve();
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            const dataUpdate = [...data];
            const index = oldData.tableData.id;
            dataUpdate[index] = newData;

            editEducationMajor(oldData.eduMajorId, newData.eduMajorName)
              .then(result => {
                sweetAlerts.success("แก้ไขข้อมูลเรียบร้อยแล้ว");
                setData([...dataUpdate]);
              })
              .catch(err => {
                const errorMsg = err.response?.data?.desc || err.message || "เกิดข้อผิดพลาด";
                sweetAlerts.error("ไม่สามารถแก้ไข อปท.", errorMsg);
              });
            resolve();
          }),
        onRowDelete: oldData =>
          new Promise((resolve, reject) => {
            const dataDelete = [...data];
            const index = oldData.tableData.id;
            dataDelete.splice(index, 1);

            deleteEducationMajor(oldData.eduMajorId)
              .then(result => {
                sweetAlerts.success("ลบข้อมูลเรียบร้อยแล้ว");
                setData([...dataDelete]);
              })
              .catch(err => {
                sweetAlerts.error("ไม่สามารถลบข้อมูลได้", err.toString());
              });
            resolve();
          })
      }}
    />
  );
};
export default EducationMajor;
